import request from '@/utils/request'

// 影像列表
export function listAll(data) {
  return request({
    url: '/news/listAll',
    method: 'post',
    data
  })
}

// 新增影像
export function newsSave(data) {
  return request({
    url: '/news/save',
    method: 'post',
    data
  })
}
// 回显信息
export function newsGetNews(data) {
  return request({
    url: '/news/getNews',
    method: 'get',
    params: data
  })
}

// 下一条影像id
export function getNextOne(data) {
  return request({
    url: '/news/getNextOne',
    method: 'post',
    data
  })
}

// 修改影像
export function updateNews(data) {
  return request({
    url: '/news/updateNews',
    method: 'post',
    data
  })
}

// 修改影像查看状态为是
export function updateExamine(data) {
  return request({
    url: '/news/updateExamine',
    method: 'get',
    params: data
  })
}

// 影像列表各类型总数
export function NewsListCount(data) {
  return request({
    url: '/news/NewsListCount',
    method: 'post',
    data
  })
}

// 影像人数+1
export function updateNewsNumber(data) {
  return request({
    url: '/news/updateNewsNumber',
    method: 'get',
    params: data
  })
}

// 是否认证成功
export function selectIsAuthentication(data) {
  return request({
    url: '/news/selectIsAuthentication',
    method: 'get',
    params: data
  })
}

// 通过主键查询用户详情
export function queryByIds(data) {
  return request({
    url: '/apiUser/queryByIds',
    method: 'get',
    params: data
  })
}

// 签约上传作品
export function updateWorks(data) {
  return request({
    url: '/apiUser/updateWorks',
    method: 'post',
    data
  })
}

// 审核列表一览
export function selectCertificationInfo(data) {
  return request({
    url: '/apiUser/selectCertificationInfo',
    method: 'post',
    data
  })
}

// 敏感词一览/h5端敏感词检索
export function sensitiveWordAll(data) {
  return request({
    url: '/arrange/sensitiveWordAll',
    method: 'post',
    data
  })
}

// 黑名单一览/h5端黑名单检索
export function blacklistWordAll(data) {
  return request({
    url: '/arrange/blacklistWordAll',
    method: 'post',
    data
  })
}

// 检索词新增/h5端查询时检索词新增
export function searchingWordSave(data) {
  return request({
    url: '/arrange/searchingWordSave',
    method: 'get',
    params: data
  })
}
//查询当日新增序号（传1：图片；2：下载）
export function selectDayNumber(data) {
  return request({
    url: '/news/selectDayNumber',
    method: 'get',
    params: data
  })
}
